export default "__VITE_ASSET__DHrtnT7S__"